export interface ShippingManifestData {
    LabRequisitionID: number;
    LabRequestID: number;
    EquipmentDisplayName: string;
    EquipmentID: number;
    Modality: string;
    TestDisplayName: string;
    LabContainerMasterId: number;
    LabContainerID: string;
    PrintLabelDate: Date | string;
    PrintLabelDateSort: Date
    DrawDate: string | null;
    DrawDateSort: Date;
    ShippingDate: Date | string;
    ShippingDateSort: Date;
    ContainerDescription: string;
    DrawTime: string;
    isDisabled: boolean;
    IsProfile: boolean
    ProfileTestJSON: string | null;
    RequisitionCreateDate: Date;
    ShippingManifestID: number;
    ContainerDisplayName: string | null;
    IsShipmentReceived: boolean;
    ShipmentReceivedDate: Date | null;
    WorkFlow: string;
    ModelNumber: string;
}
export interface Month {
    name: string;
    short: string;
    number: number;
    days: number;
}
export interface Year {
    name: string | number;
    key: number | string;
}
export interface Time {
    label: string;
    value: number | string;
}
export interface FirstPrintLabelDateResponse {
    LabRequisitionID: number;
    FirstPrintLabelDate: Date | string;
}

export enum TASK {
    PRINT_LABEL ='print-label',
    PRINT_MANIFEST='print-mainfest'
}
